import { TabGroup } from '@headlessui/react';
import { PlTab, PlTabList } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, Fragment, ReactNode, useState } from 'react';

type TabConfig = {
  label: string;
};

export type SidebarSplitProps = {
  leftTab: TabConfig;
  rightTab: TabConfig;
  /**
   * Two children, rendered into the left and right panels respectively.
   * Both panels stay mounted at all sizes — when narrow the inactive panel is
   * hidden via CSS so any form/input state inside is preserved when the user
   * switches tabs.
   */
  children: [ReactNode, ReactNode];
};

const SidebarSplit: FC<SidebarSplitProps> = (props) => {
  const { leftTab, rightTab, children } = props;
  const [selectedIndex, setSelectedIndex] = useState<0 | 1>(0);
  const [leftChild, rightChild] = children;

  return (
    <div className="@container/sidebarsplit h-full grow min-h-0">
      {/* oxlint-disable-next-line payaca/no-tailwind-arbitrary-values */}
      <div className="grid h-full min-h-0 grid-rows-[auto_minmax(0,1fr)] @screen-md/sidebarsplit:grid-rows-1">
        <TabGroup
          as="div"
          className="p-3.5 pb-0 @screen-md/sidebarsplit:hidden"
          selectedIndex={selectedIndex}
          onChange={(i) => setSelectedIndex(i as 0 | 1)}
        >
          <PlTabList className="w-full" variant="segment">
            <PlTab fullWidth variant="segment">
              {leftTab.label}
            </PlTab>
            <PlTab fullWidth variant="segment">
              {rightTab.label}
            </PlTab>
          </PlTabList>
        </TabGroup>

        <div className="grid min-h-0 grid-cols-1 @screen-md/sidebarsplit:grid-cols-2">
          <div
            className={clstx(
              'grid min-h-0 grid-rows-1 overflow-hidden',
              selectedIndex !== 0 && 'hidden @screen-md/sidebarsplit:grid'
            )}
          >
            {leftChild}
          </div>
          <div
            className={clstx(
              'grid min-h-0 grid-rows-1 overflow-hidden @screen-md/sidebarsplit:border-l',
              selectedIndex !== 1 && 'hidden @screen-md/sidebarsplit:grid'
            )}
          >
            {rightChild}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarSplit;
